import React from 'react';

interface PhoneInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function PhoneInput({
  value = '',
  onChange,
  placeholder = '23282363',
  disabled = false,
  className = '',
}: PhoneInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Nettoyer le texte pour ne garder que les chiffres
    const cleanText = e.target.value.replace(/[^0-9]/g, '');
    onChange?.(cleanText);
  };

  return (
    <div className={`relative w-full ${className}`}>
      <div className="flex items-center border border-gray-300 rounded-lg bg-white w-full">
        {/* Indicatif tunisien avec drapeau */}
        <div className="flex items-center px-3 py-2 border-r border-gray-300 bg-gray-50 flex-shrink-0">
          <span className="text-lg mr-2">🇹🇳</span>
          <span className="text-gray-500 font-medium text-sm">+216</span>
        </div>
        
        {/* Champ de saisie pour le numéro */}
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={disabled}
          className="flex-1 px-3 py-2 border-0 outline-none text-base w-full min-w-0"
          style={{
            border: 'none',
            boxShadow: 'none',
            width: '100%',
          }}
          maxLength={8} // Limite à 8 chiffres pour un numéro tunisien
        />
      </div>
    </div>
  );
}
